// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__1AitK","active":"NavItem_active__BPA9x"};